<template>
	<div class="geral">
        <empty-table-message v-if="isEmpty"/>
        <div v-else-if="data">
            <div v-for="(value, key) in data" :key="key">
                <div
                    v-if="$te(key)" 
                    class="column">
                    <div class="container">
                        <label v-text="`${$t(key)}: `"></label>
                        <span class="item"> {{ value }} </span>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
export default {
    props: {
        data: Object,
    },
	data() {
        return {
            isEmpty: false,
		};
    },
    created() {
        if (this.data) {
            this.isEmpty = Object.keys(this.data).length === 0;
        }
    },
};
</script>

<style lang="scss" scoped>
.geral {
    display: flex;
    height: 100%;
    
    .column {
        padding: 3px;
    }
    .container {
        display: flex;
        align-items: center;
    }
    label {
        color: $sovis-black;
        padding-right: 5px;
    }
    .item {
        font-size: 12px;
    }
}   
</style>